import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class Gebaeude extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    kanton_id: number | null = null;
    jahr: number | null = null;
    angrenzende_gebaeude: number[] | null = null;
    egid: number | null = null;
    name_des_gebaeudes: string | null = null;
    strassenname: string | null = null;
    hausnummer: string | null = null;
    plz: string | null = null;
    ort: string | null = null;
    bfs_gemeindenummer: number | null = null;
    gebaeudestatus: number | null = null;
    gebaeudekategorie: number | null = null;
    gebaeudeklasse: number | null = null;
    baujahr: number | null = null;
    bauperiode_calc: number | null = null;
    nutzungsart_id: number | null = null;
    gebaeudeflaeche: number | null = null;
    gebaeudevolumen: number | null = null;
    anzahl_geschosse: number | null = null;
    anzahl_wohnungen_calc: number | null = null;
    anzahl_zimmer_calc: number | null = null;
    wohnungsflaeche_calc: number | null = null;
    energiebezugsflaeche: number | null = null;
    energiebezugsflaeche_calc: number | null = null;
    waermeerzeuger_heizung_1: number | null = null;
    waermeerzeuger_heizung_2: number | null = null;
    energie_waermequelle_heizung_1: number | null = null;
    energie_waermequelle_heizung_2: number | null = null;
    datum_aktualisierung_heizung_1: Dayjs | null = null;
    datum_aktualisierung_heizung_2: Dayjs | null = null;
    technologie_heizung_1: number | null = null;
    technologie_heizung_2: number | null = null;
    waermeerzeuger_warmwasser_1: number | null = null;
    waermeerzeuger_warmwasser_2: number | null = null;
    energie_waermequelle_warmwasser_1: number | null = null;
    energie_waermequelle_warmwasser_2: number | null = null;
    datum_aktualisierung_warmwasser_1: Dayjs | null = null;
    datum_aktualisierung_warmwasser_2: Dayjs | null = null;
    technologie_warmwasser_1: number | null = null;
    technologie_warmwasser_2: number | null = null;
    e_koordinate: number | null = null;
    n_koordinate: number | null = null;
    waermeerzeuger_heizung_1_calc: number | null = null;
    waermeerzeuger_heizung_2_calc: number | null = null;
    energie_waermequelle_heizung_1_calc: number | null = null;
    energie_waermequelle_heizung_2_calc: number | null = null;
    waermeerzeuger_warmwasser_1_calc: number | null = null;
    waermeerzeuger_warmwasser_2_calc: number | null = null;
    energie_waermequelle_warmwasser_1_calc: number | null = null;
    energie_waermequelle_warmwasser_2_calc: number | null = null;
    anzahl_angrenzende_beheizte_gebaeude_calc: number | null = null;
    anteil_heizung_1_calc: number | null = null;
    anteil_heizung_2_calc: number | null = null;
    nutzungsgrad_heizung_1_calc: number | null = null;
    nutzungsgrad_heizung_2_calc: number | null = null;
    standard_nutzenergie_raumwaerme_calc: number | null = null;
    standard_waermebedarf_heizung_1_calc: number | null = null;
    standard_waermebedarf_heizung_2_calc: number | null = null;
    anteil_warmwasser_1_calc: number | null = null;
    anteil_warmwasser_2_calc: number | null = null;
    nutzungsgrad_warmwasser_1_calc: number | null = null;
    nutzungsgrad_warmwasser_2_calc: number | null = null;
    standard_nutzenergie_warmwasser_calc: number | null = null;
    standard_waermebedarf_warmwasser_1_calc: number | null = null;
    standard_waermebedarf_warmwasser_2_calc: number | null = null;
    waermebedarf_heizung_calc: number | null = null;
    waermebedarf_warmwasser_calc: number | null = null;
    waermebedarf_total_calc: number | null = null;
    e_gebaeudekoordinate: number | null = null;
    n_gebaeudekoordinate: number | null = null;


    // view fields
    nutzungsart: string | null = null;
    kanton: string | null = null;
    kanton_kuerzel: string | null = null;


    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
            datum_aktualisierung_heizung_1: (val) => dayjs(val),
            datum_aktualisierung_heizung_2: (val) => dayjs(val),
            datum_aktualisierung_warmwasser_1: (val) => dayjs(val),
            datum_aktualisierung_warmwasser_2: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'Gebaeude';
    }
}

export async function createNewGebaeude(): Promise<Gebaeude> {
    const model = createModel(Gebaeude, {});

    await model.save();
    return model;
}

export class GebaeudeCollection extends BaseCollection<Gebaeude> {
    protected modelCls = Gebaeude;

    public getModelClassName(): string {
        return 'Gebaeude';
    }
}
